module.exports = __webpack_public_path__ + "static/rzutCB-6db8ff1ec0412d822cc6827ed8cfcbf6.png";